import { Link, useLocation } from "react-router-dom";
import { locationToPaths } from "../../helpers";
import {
  HiHome,
  HiClipboardList,
  HiCube,
  HiCog,
  HiChevronLeft,
  HiChevronRight,
} from "react-icons/hi";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

// Map path names to modern SaaS icons
const breadcrumbIcons = {
  Dashboard: <HiHome className="h-4 w-4 text-gray-400 mr-1" />,
  Orders: <HiClipboardList className="h-4 w-4 text-gray-400 mr-1" />,
  Ship: <HiCube className="h-4 w-4 text-gray-400 mr-1" />,
  Settings: <HiCog className="h-4 w-4 text-gray-400 mr-1" />,
};

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const paths = locationToPaths(pathname);

  return (
    <div className="mb-3">
      {/* Mobile back button */}
      <nav className="sm:hidden" aria-label="Back">
        <Link
          to={".."}
          className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700"
        >
          <HiChevronLeft className="-ml-1 mr-1 h-5 w-5 text-gray-400" />
          Back
        </Link>
      </nav>

      {/* Desktop breadcrumb */}
      <nav className="hidden sm:flex" aria-label="Breadcrumb">
        <ol className="flex items-center space-x-4">
          {paths.map((p, i) => (
            <li key={i}>
              <div className={classNames(i !== 0 && "items-center", "flex")}>
                {i !== 0 && (
                  <HiChevronRight className="h-5 w-5 flex-shrink-0 text-gray-400" />
                )}
                <Link
                  to={p.link}
                  className={classNames(
                    i !== 0 && "ml-2",
                    "flex items-center text-sm font-medium text-gray-500 hover:text-gray-700"
                  )}
                >
                  {breadcrumbIcons[p.name] || <HiCube className="h-4 w-4 text-gray-400 mr-1" />}
                  {p.name}
                </Link>
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}